# Allows to use events in stimulus. Check this issue for more information.
# https://github.com/hotwired/stimulus/issues/78

# ~ Dispatch jQuery events as regular DOM events ~
#
# Delegated events are given a new name in the format `jquery:<original event name>`.
# If you delegate `ajax:send` you will be able to listen for `jquery:ajax:send`
# on native event listeners such as Stimulus actions and `EventTarget.addEventListener`.
#
# Notes:
#   * The first parameter must be called "event".
#   * The parameters can be accessed as members on the `event.detail` object.
#
# Example:
#   delegate 'ajax:send', parameters: ['event', 'xhr']
#   document.addEventListener 'jquery:ajax:send', (event) -> console.log(event.detail)
#
delegate = (eventName, {parameters}) ->
  handler = (args...) ->
    data = {}
    data[name] = args[index] for name, index in parameters
    delegatedEvent = new CustomEvent("jquery:#{eventName}",
      bubbles: true,
      cancelable: true,
      detail: data)
    data.event.target.dispatchEvent(delegatedEvent)
  $(document).on(eventName, handler)


# jQuery UJS
#
# Source: https://github.com/rails/jquery-ujs/wiki/ajax
#
delegate 'ajax:before',           parameters: ['event']
delegate 'ajax:beforeSend',       parameters: ['event', 'xhr', 'settings']
delegate 'ajax:send',             parameters: ['event', 'xhr']
delegate 'ajax:success',          parameters: ['event', 'data', 'status', 'xhr']
delegate 'ajax:error',            parameters: ['event', 'xhr', 'status', 'error']
delegate 'ajax:complete',         parameters: ['event', 'xhr', 'status']
delegate 'ajax:aborted:required', parameters: ['event', 'elements']
delegate 'ajax:aborted:file',     parameters: ['event', 'elements']
